module.exports = __webpack_public_path__ + "img/banner_xfzx.878fc14f.jpg";